import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';

export const getAuthFeatureState = createFeatureSelector('auth');

export const selectPhone = createSelector(getAuthFeatureState, (state: AuthState) => state.phone);

export const selectCustomer = createSelector(
  getAuthFeatureState,
  (state: AuthState) => state.customer
);

export const selectResend = createSelector(getAuthFeatureState, (state: AuthState) => state.resend);

export const selectOtpIsLoading = createSelector(
  getAuthFeatureState,
  (state: AuthState) => state.isLoading
);

export const selectError = createSelector(getAuthFeatureState, (state: AuthState) => state.error);

export const selectCountErrorOTP = createSelector(
  getAuthFeatureState,
  (state: AuthState) => state.countErrorOTP
);

export const selectCaptcha = createSelector(getAuthFeatureState, (state: AuthState) => state.token);

export const selectCurrentTime = createSelector(
  getAuthFeatureState,
  (state: AuthState) => state.currentTime
);
